import { atom } from 'jotai'
import { Toast } from 'primereact/toast'

export const toastAtom = atom<null | Toast>(null)
